module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-sensorcloud-1b94d1ff5e7ec086e55052aa611b7b9f.png";